import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

// Die importierten Interfaces/Datenmodels
import { StateService } from '../../services/state.service';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'default-actions',
  templateUrl: './default-actions.component.html',
  styleUrls: ['./default-actions.component.css']
})

export class DefaultActionsComponent {

  /**
   * @var EventEmitter
   */
  @Output()
  actionEmitter = new EventEmitter<string>();

  /**
   * Die derzeit durchgeführte Aktion
   *
   * @var null|string
   */
  public workingMode = null;

  constructor(
    public stateService: StateService, public loading: LoadingService
  ) {
    this.loading.setLoadingState(true);
  }

  /**
   * Gibt die ausgewählte Actions an das Elternelement zurück
   *
   * @param type
   */
  public emitAction = (type: string) => {
    if (type === 'new' || type === 'edit') {
      this.workingMode = type;
    }

    this.actionEmitter.emit(type);
  }

  /**
   * Funktion zum zurücksetzen der Aktionsleiste
   */
  public resetActions = () => {
    this.workingMode = null;
  }

  /**
   * Gibt die derzeit aktive Action zurück
   *
   * @returns string
   */
  public getMode = () => {
    return this.workingMode;
  }

}
